
// frontend/app/exhibit/v2/components/ExhibitV2Stage.js

import React from "react";
import {
  StyleSheet,
  View,
  useWindowDimensions,
} from "react-native";

const STAGE_WIDTH = 1920;
const STAGE_HEIGHT = 1080;

export default function ExhibitV2Stage({ children }) {
  const { width, height } = useWindowDimensions();

  const scale = Math.min(
    width / STAGE_WIDTH,
    height / STAGE_HEIGHT
  );

  return (
    <View style={styles.viewport}>
      <View
        style={[
          styles.frame,
          {
            width: STAGE_WIDTH * scale,
            height: STAGE_HEIGHT * scale,
          },
        ]}
      >
        <View
          style={[
            styles.stage,
            {
              transform: [{ scale }],
              transformOrigin: "top left",
            },
          ]}
        >
          {children}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewport: {
    flex: 1,
    backgroundColor: "#070D17",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },

  frame: {
    position: "relative",
    overflow: "hidden",
  },

  stage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: STAGE_WIDTH,
    height: STAGE_HEIGHT,
    backgroundColor: "#070D17",
  },
});